/* eslint-disable */
import * as React from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import Badge from '@mui/material/Badge'
import MenuItem from '@mui/material/MenuItem'
import Menu from '@mui/material/Menu'
import AccountCircle from '@mui/icons-material/AccountCircle'
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined'
import MoreIcon from '@mui/icons-material/MoreVert'
import { Avatar } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { OrgAppContext } from '../../OrgAppContext'
import { getUserName } from '../../apiCalls/dashboardApi'

export default function RIAppBar() {
  const navigate = useNavigate()
  const { setCustomerId, setOrgId, setAppId, setOrgName, setAppName, customerId, orgId, appId } =
    React.useContext(OrgAppContext)
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState<null | HTMLElement>(null)
  const [initial, setInitial] = React.useState('')
  const isMenuOpen = Boolean(anchorEl)
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)

  React.useEffect(() => {
    if (customerId === '' || orgId === '' || appId === '') return
    getUserName({ customerId, orgId, appId }).then((res: any) => {
      if (!res || !res?.data?.firstname || !res?.data?.lastname || res.error) return
      const { firstname, lastname } = res.data
      const generatedInitial = `${firstname.charAt(0)}${lastname.charAt(0)}`.toUpperCase()
      setInitial(generatedInitial)
    })
  }, [customerId, orgId, appId])

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
    handleMobileMenuClose()
  }

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget)
  }
  const handleSwitchOrgAndApp = () => {
    sessionStorage.removeItem('customerId')
    sessionStorage.removeItem('orgId')
    sessionStorage.removeItem('appId')
    sessionStorage.removeItem('orgName')
    sessionStorage.removeItem('appName')
    setCustomerId('')
    setOrgId('')
    setAppId('')
    setOrgName('')
    setAppName('')
    handleMenuClose()
  }

  const handleUpdatePassword = () => {
    navigate('/password')
    handleMenuClose()
  }

  const menuId = 'primary-search-account-menu'
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {/* <MenuItem onClick={handleMenuClose}>Profile</MenuItem> */}
      <MenuItem onClick={handleSwitchOrgAndApp}>Switch Application</MenuItem>
      <MenuItem onClick={handleUpdatePassword}>Update Password</MenuItem>
      <MenuItem onClick={() => navigate('/logout')}>Logout</MenuItem>
    </Menu>
  )

  const mobileMenuId = 'primary-search-account-menu-mobile'
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton size='large' aria-label='show 4 new mails' color='inherit'>
          <SettingsOutlinedIcon />
        </IconButton>
        <p>Messages</p>
      </MenuItem>
      <MenuItem>
        <IconButton size='large' aria-label='show 17 new notifications' color='inherit'>
          <Badge badgeContent={17} color='error'>
            <NotificationsNoneOutlinedIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size='large'
          aria-label='account of current user'
          aria-controls='primary-search-account-menu'
          aria-haspopup='true'
          color='inherit'
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  )

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position='static' elevation={0}>
        <Toolbar sx={{ backgroundColor: '#494949', height: '53px', minHeight: '53px !important' }}>
          <img src={'/logo.svg'} alt='logo' style={{ height: '40px' }} />
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            {/* <IconButton size='large' color='inherit'> */}
            {/*   <SettingsOutlinedIcon /> */}
            {/* </IconButton> */}
            {/* <IconButton size='large' color='inherit'> */}
            {/*   <Badge badgeContent={5} color='error'> */}
            {/*     <NotificationsNoneOutlinedIcon /> */}
            {/*   </Badge> */}
            {/* </IconButton> */}
            <IconButton
              size='large'
              edge='end'
              aria-label='account of current user'
              aria-controls={menuId}
              aria-haspopup='true'
              onClick={handleProfileMenuOpen}
              color='inherit'
            >
              <Avatar sx={{ width: '35px', height: '35px', fontSize: '13px' }}>{initial}</Avatar>
            </IconButton>
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size='large'
              aria-label='show more'
              aria-controls={mobileMenuId}
              aria-haspopup='true'
              onClick={handleMobileMenuOpen}
              color='inherit'
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </Box>
  )
}
